import { h } from "preact";
import { useState } from "preact/hooks";

import { Modify } from "../../../../foundation/utils/UtilityTypes";
import Checkbox from "../../Checkbox";
import Alert, { AlertProps } from "..";

import styles from "./DismissibleAlert.module.css";

interface Props extends Omit<AlertProps, "children" | "primaryButtonProps"> {
    dismissPrefKey: string;
    primaryButtonProps: Modify<NonNullable<AlertProps["primaryButtonProps"]>, {
        onClick: (e: Record<string, boolean>) => void;
    }>;
}

export default function DismissibleAlert({
    primaryButtonProps: {
        onClick: onPrimaryButtonClick,
        ...primaryButtonProps
    },
    dismissPrefKey,
    ...props
}: Props) {
    const [dismissChecked, setDismissChecked] = useState(false);

    function handlePrimaryButtonClick() {
        onPrimaryButtonClick({ [dismissPrefKey]: dismissChecked });
    }

    function handleDismissCheckChange() {
        setDismissChecked(!dismissChecked);
    }

    return (
        <Alert
            {...props}
            childrenClass={styles.children}
            primaryButtonProps={{
                ...primaryButtonProps,
                onClick: handlePrimaryButtonClick
            }}>
            <label class={styles.dismissLabel}>
                <Checkbox
                    checked={dismissChecked}
                    onChange={handleDismissCheckChange}/>
                <span class="body-1">
                    Do not show this message again.
                </span>
            </label>
        </Alert>
    );
}
